import { isoWeekNumber } from '@/utils/appointmentTimeFormat';

/** Monday-first column headers, including the week-number column. */
export const DANISH_CALENDAR_WEEKDAYS = ['uge', 'ma', 'ti', 'on', 'to', 'fr', 'lø', 'sø'] as const;
export const ENGLISH_CALENDAR_WEEKDAYS = ['wk', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'] as const;

export function calendarWeekdayLabels(language: string): readonly string[] {
  return language.toLowerCase().startsWith('en') ? ENGLISH_CALENDAR_WEEKDAYS : DANISH_CALENDAR_WEEKDAYS;
}

/** Monday-first month grid. `days` entries are the day of the month, or null for padding. */
export function danishCalendarMonthGrid(
  year: number,
  monthIndex: number,
): { week: number; days: (number | null)[] }[] {
  const first = new Date(Date.UTC(year, monthIndex, 1, 12, 0, 0));
  const firstWeekday = (first.getUTCDay() + 6) % 7;
  const daysInMonth = new Date(Date.UTC(year, monthIndex + 1, 0, 12, 0, 0)).getUTCDate();
  const cells: (number | null)[] = [
    ...Array(firstWeekday).fill(null),
    ...Array.from({ length: daysInMonth }, (_, i) => i + 1),
  ];
  while (cells.length % 7 !== 0) cells.push(null);
  const rows: { week: number; days: (number | null)[] }[] = [];
  for (let i = 0; i < cells.length; i += 7) {
    const days = cells.slice(i, i + 7);
    const anchor = days.find((day): day is number => day != null) ?? 1;
    rows.push({ week: isoWeekNumber(new Date(Date.UTC(year, monthIndex, anchor))), days });
  }
  return rows;
}
